import { MapPin, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { experiences } from "../../data/mock";
import SectionHeading from "../SectionHeading";

const Experience = () => {
  return (
    <section id="experience" className="relative py-24 sm:py-28">
      <div className="rule mb-24" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          index="02"
          eyebrow="Track record"
          title="Professional"
          accent="experience"
        >
          Building production and enterprise systems on the .NET stack since 2022 —
          from intern to leading backend on a live factory-floor MES.
        </SectionHeading>

        <div className="mt-16 relative">
          {/* Rail */}
          <div className="absolute left-0 sm:left-2 top-2 bottom-2 w-px bg-line" />

          <div className="space-y-4">
            {experiences.map((exp) => (
              <div key={exp.id} className="relative pl-8 sm:pl-12">
                {/* Node */}
                <div className="absolute left-0 sm:left-2 top-8 -translate-x-1/2 w-3 h-3 rounded-full bg-signal ring-4 ring-ink" />

                <div className="relative bg-panel/70 backdrop-blur-sm border border-line rounded-lg p-7 sm:p-8 panel-ticks group hover:border-line transition-colors">
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-4">
                    <span className="font-mono text-xs px-2.5 py-1 rounded bg-signal/10 text-signal border border-signal/25">
                      {exp.duration}
                    </span>
                    <span className="flex items-center gap-1.5 font-mono text-xs text-fg-mute">
                      <MapPin className="w-3.5 h-3.5" />
                      {exp.location}
                    </span>
                  </div>

                  <h3 className="font-display text-2xl font-bold text-fg group-hover:text-signal transition-colors">
                    {exp.position}
                  </h3>
                  <p className="text-fg-dim font-medium mt-1">{exp.company}</p>

                  <p className="mt-5 text-fg-dim leading-relaxed">{exp.description}</p>

                  <div className="mt-6 flex flex-wrap gap-2">
                    {exp.technologies.map((tech) => (
                      <span
                        key={tech}
                        className="font-mono text-xs px-2.5 py-1 rounded bg-panel2 text-fg-dim border border-line"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  <ul className="mt-6 space-y-2.5">
                    {exp.achievements.map((a, i) => (
                      <li key={i} className="flex gap-3 text-sm text-fg-dim leading-relaxed">
                        <span className="text-signal mt-1 shrink-0 font-mono text-xs">→</span>
                        <span>{a}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/contact"
            className="group inline-flex items-center gap-2 px-6 py-3.5 border border-line text-fg rounded-md font-semibold hover:border-signal/60 hover:text-signal transition-colors"
          >
            Let's build something
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Experience;
